export default __webpack_public_path__ + "static/media/clouds.609997fe.png";